module.exports = __webpack_public_path__ + "img/234-e158a3.png";